module.exports = __webpack_public_path__ + "static/solowheel-9c4a253b498376227ae98c59cab22162.jpg";